<template>
    <div>
        <!-- burger -->
        <button class="block w-10 py-2 px-2 border-white focus:outline-none border-2 focus:border-none rounded-lg md:hidden" @click="toggle()" v-if="!burgerOpen">
        <!-- v-bind:class="{ 'invisible': this.burgerOpen }" -->
            <div class="block border-b border-gray-700 h-2 pt-1"></div>
            <div class="block border-b border-gray-700 h-2 pt-1"></div>
            <div class="block border-b border-gray-700 h-2 pt-1"></div>
        </button>

        <button class="fixed inset-0 w-full h-full bg-black opacity-25" tabindex="-1" @click="burgerOpen = false" v-if="burgerOpen"></button>

        <div class="absolute right-0 w-48 bg-white rounded shadow-lg" v-if="burgerOpen">
            <a href="/patients"             class="block p-2 hover:bg-pink-300 uppercase no-underline font-nav">For Patients</a>
            <a href="/prescribers"          class="block p-2 hover:bg-pink-300 uppercase no-underline font-nav">For Prescribers</a>
            <a href="/what-is-domperidone"  class="block p-2 hover:bg-pink-300 uppercase no-underline font-nav">About Domperidone</a>
            <a href="/about-us"             class="block p-2 hover:bg-pink-300 uppercase no-underline font-nav">About Us</a>
            <a href="/contact-us"           class="block p-2 hover:bg-pink-300 uppercase no-underline font-nav">Contact Us</a>
        </div>

        <!-- navigation -->
        <nav class="hidden md:flex w-2/3">
            <ul class="flex cursor-pointer font-nav font-light tracking-wide">
                <li class="flex-none mx-2 px-2 pb-1">
                    <a href="/patients" class="uppercase no-underline text-sm text-gray-800 hover:border-pink-300 border-b-2 border-white pb-1">For Patients</a>
                </li>
                <li class="flex-none mx-2 px-2 pb-1">
                    <a href="/prescribers" class="uppercase no-underline text-sm text-gray-800 hover:border-pink-300 border-b-2 border-white pb-1">For Prescribers</a>
                </li>
                <li class="flex-none mx-2 px-2 pb-1">
                    <a href="/what-is-domperidone" class="uppercase no-underline text-sm text-gray-800 hover:border-pink-300 border-b-2 border-white pb-1">About Domperidone</a>
                </li>
                <li class="flex-none mx-2 px-2 pb-1">
                    <a href="/about-us" class="uppercase no-underline text-sm text-gray-800 hover:border-pink-300 border-b-2 border-white pb-1">About Us</a>
                </li>
                <li class="flex-none mx-2 px-2 pb-1">
                    <a href="/contact-us" class="uppercase no-underline text-sm text-gray-800 hover:border-pink-300 border-b-2 border-white pb-1">Contact Us</a>
                </li>
            </ul>
        </nav>

    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                burgerOpen: false
            }
        },
        methods: {
            toggle: function() {
                this.burgerOpen = !this.burgerOpen;
                console.log(this.burgerOpen)
            }
        },
        created() {
            const handleEscape = (e) => {
                let key = event.key || event.keyCode;

                if (key === 'Esc' || key === 'Escape' || key === 27) {
                    console.log('found an escape')
                    this.burgerOpen = false
                    console.log(this.burgerOpen)
                }
            }

            document.addEventListener('keyup', handleEscape)

            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('keyup', handleEscape)
            })

        },
        mounted() {
            console.log('Component mounted.');
        }
    }
</script>
